<template>
  <div class="lg:py-0 md:py-0 py-12 lg:px-0 md:px-0 px-4">
    <img
      src="@/assets/images/line/Frame 1000002302.png"
      alt="lineimg"
      class="m-auto"
    />
    <TestimonialDetailsPopup
      :isActive="isDetailsActive"
      :selectedTesimonial="selectedTesimonial"
      @close="toggleDetails"
    />
    <div class="relative flex mob-hidden">
      <div class="absolute bg-designGT">
        <img src="../../../assets/images/bg-des/bgdTG.svg" alt="bg-polygon" />
      </div>
      <div class="absolute bg-design-dots-tsm mob-hidden">
        <img src="../../../assets/images/Ellipse 12.svg" alt="bg-polygon" />
      </div>
    </div>
    <p
      class="title sm-fsize16 lg:font-normal md:font-normal font-bold lg:pb-8 md:pb-8 pb-4 lg:px-12 md:px-12"
    >
      Testimonials
    </p>
    <div class="example-3d" @mouseenter="mouseover" @mouseleave="mouseleave">
      <swiper class="swiper" :options="swiperOptions">
        <swiper-slide
          class="sm-h-auto cursor-pointer"
          v-for="(item, index) in testimonals"
          :key="index"
        >
          <div class="w-full p-8 cust-bg" @click="toggleDetails(true, item)">
            <div class="">
              <!-- <img :src="item.quotesImgopen" alt="quotesimg" class="w-4 h-4" /> -->
              <p
                class="pt-2 clr777 font-normal fsize16px italic ellipsis-6 md-ellipsis-6"
              >
                <span class="text-0193a1 fsize25"> ❝</span>
                {{ item.text }}
                <span class="text-0193a1 fsize25"> ❞</span>
              </p>
              <!-- <img :src="item.quotesImgclose" alt="quotesimg" class="w-4 h-4" /> -->
              <div class="mx-auto text-center">
                <img
                  :src="item.userImg"
                  class="mt-6 rounded-full w-20 h-20 border-user mx-auto object-contain"
                  alt=""
                />
                <p class="pt-3 font-normal fsize14px text-black uppercase">
                  {{ item.name }}
                </p>
                <p class="text-sm pt-1 clr777 font-light">
                  {{ item.description }}
                </p>
              </div>
            </div>
          </div>
        </swiper-slide>

        <div class="swiper-pagination cust-posi" slot="pagination"></div>
      </swiper>
    </div>
  </div>
</template>

<script>
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/dist/css/swiper.min.css";

import TestimonialDetailsPopup from "./TestimonialDetailsPopup";
export default {
  components: {
    swiper,
    swiperSlide,
    TestimonialDetailsPopup,
  },
  data() {
    return {
      selectedTesimonial: {},
      autoplay: {
        delay: 4000,
        disableOnInteraction: false,
      },
      testimonals: [
        {
          id: "01",
          quotesImgopen: require("../../../assets/images/comma.png"),
          text: "We would like to express our profound gratitude to you for helping us complete the 3-module workshop on Caregiving and its importance, for our people in Accenture Operations.</p> <p>This was the first time that we were able to introduce a program of such unique nature for our employees, and we have been getting great feedback from attendees. <p> We greatly appreciate your time and contributions towards making this program a success and helping us create awareness on the relevance of caregivers in today’s age and the crucial role they play. Most importantly, we are happy to have been able to highlight the various dimensions of caregiving and hope that this is a stepping stone towards increasing our employees' understanding of caregiving and caregivers better.",
          quotesImgclose: require("../../../assets/images/commaclose.png"),
          userImg: require("../../../assets/images/corporate-log/Accenture-logo.png"),
          name: "Accenture",
          description: "Corporate Partner",
          html: `<p class="">“We would like to express our profound gratitude to you for helping us complete the 3-module workshop on Caregiving and its importance, for our people in Accenture Operations.</p> <p>This was the first time that we were able to introduce a program of such unique nature for our employees, and we have been getting great feedback from attendees. <p> We greatly appreciate your time and contributions towards making this program a success and helping us create awareness on the relevance of caregivers in today’s age and the crucial role they play. Most importantly, we are happy to have been able to highlight the various dimensions of caregiving and hope that this is a stepping stone towards increasing our employees' understanding of caregiving and caregivers better.”</p>`,
        },
        {
          id: "02",
          quotesImgopen: require("../../../assets/images/comma.png"),
          text: "We really enjoyed putting the session together with you - thank you for your flexibility and incorporating all our requirements</p><p>Although it was an hour, it was a power-packed session that was an eye-opener and left us with many ideas on what we need to prepare for, how we can build resilience and incorporate sensitivity to caregivers who are all around us - in our families and at our workplaces.",
          quotesImgclose: require("../../../assets/images/commaclose.png"),
          userImg: require("../../../assets/images/corporate-log/google.png"),
          name: " GOOGLE",
          description: "Corporate Partner",
          html: `<p class="">We really enjoyed putting the session together with you - thank you for your flexibility and incorporating all our requirements</p><p>Although it was an hour, it was a power-packed session that was an eye-opener and left us with many ideas on what we need to prepare for, how we can build resilience and incorporate sensitivity to caregivers who are all around us - in our families and at our workplaces."</p>`,
        },
        {
          id: "03",
          quotesImgopen: require("../../../assets/images/comma.png"),
          text: "Really enjoyed the interactive and insightful session - it is an increasing need of the hour. The session was very engaging and left us with many ideas on how we can integrate this critical aspect of our lives",
          quotesImgclose: require("../../../assets/images/commaclose.png"),
          userImg: require("../../../assets/images/corporate-log/Ford.png"),
          name: "FORD COMPANY",
          description: "Corporate Partner",
          html: `<p class="">"Really enjoyed the interactive and insightful session - it is an increasing need of the hour. The session was very engaging and left us with many ideas on how we can integrate this critical aspect of our lives"</p>`,
        },
        {
          id: "04",
          quotesImgopen: require("../../../assets/images/comma.png"),
          text: "“Leaders and organizations have a big role in helping people dealing with grief by which we are all touched in this pandemic by one way or another. We have lost loved ones, jobs, social connections, even the sense of normalcy. People cannot turn off grief when they step into the workplace again. So leaders are required to do something about this. They need to meet the emotional needs of the employees, they need to know how to support someone who is devastated or feeling emotional. So if you are a leader and looking for a handy resource to show you how to do that, the Grief Handbook is an easy guide- how to understand grieving, how to create psychological safety, what processes should you set up in your organization, or maybe what you really say to a person who has suffered a loss, this handbook is a good start. It is a tangible and practical tool which will equip you as a leader.”",
          quotesImgclose: require("../../../assets/images/commaclose.png"),
          userImg: require("../../../assets/images/PicturesSet/Testimonials/JMB.jpg"),
          name: "Jayashree M Braganza",
          description: "Coach, Counselor and Consultant",
          html: `<p class="">“Leaders and organizations have a big role in helping people dealing with grief by which we are all touched in this pandemic by one way or another. We have lost loved ones, jobs, social connections, even the sense of normalcy. People cannot turn off grief when they step into the workplace again. So leaders are required to do something about this. They need to meet the emotional needs of the employees, they need to know how to support someone who is devastated or feeling emotional. So if you are a leader and looking for a handy resource to show you how to do that, the Grief Handbook is an easy guide- how to understand grieving, how to create psychological safety, what processes should you set up in your organization, or maybe what you really say to a person who has suffered a loss, this handbook is a good start. It is a tangible and practical tool which will equip you as a leader.”</p>`,
        },
        {
          id: "05",
          quotesImgopen: require("../../../assets/images/comma.png"),
          text: "“This is a seminal handbook for workplaces to begin to understand what grief looks like and how it can be crippling to the daily functioning of a person. It helps organizations realize that a grieving employee requires space and compassion to recover and heal and to provide reasonable accommodation to enable this. The handbook even addresses the age-old awkwardness of how to address someone who is recently bereaved. A must read for any time, but particularly critical in the wake of the current pandemic.”",
          quotesImgclose: require("../../../assets/images/commaclose.png"),
          userImg: require("../../../assets/images/PicturesSet/Testimonials/Devika Dharmaraj.jpeg"),
          name: "Devika Dharmaraj",
          description: "Mental Health and HR Consultant",
          html: `<p class="">“This is a seminal handbook for workplaces to begin to understand what grief looks like and how it can be crippling to the daily functioning of a person. It helps organizations realize that a grieving employee requires space and compassion to recover and heal and to provide reasonable accommodation to enable this. The handbook even addresses the age-old awkwardness of how to address someone who is recently bereaved. A must read for any time, but particularly critical in the wake of the current pandemic.”</p>`,
        },
      ],
      swiperOptions: {
        effect: "coverflow",
        grabCursor: true,
        centeredSlides: true,
        slidesPerView: 2.2,
        spaceBetween: 170,
        loop: true,
        autoplay: {
          delay: 4000,
          disableOnInteraction: false,
        },
        roundLengths: true,
        coverflowEffect: {
          rotate: 0,
          stretch: 0,
          depth: 100,
          modifier: 3,
          slideShadows: true,
        },
        breakpoints: {
          1600: {
            slidesPerView: 2,
            spaceBetween: 180,
          },
          1300: {
            slidesPerView: 2,
            spaceBetween: 180,
          },
          900: {
            slidesPerView: 2,
            spaceBetween: 180,
          },
          640: {
            slidesPerView: 2,
            spaceBetween: 180,
          },
          505: {
            slidesPerView: 1,
            spaceBetween: 55,
          },
        },
        pagination: {
          el: ".swiper-pagination",
        },
      },
      isDetailsActive: false,
    };
  },

  computed: {
    async swiper() {
      return this.$refs.mySwiper.swiper;
    },
  },
  methods: {
    async toggleDetails(val = false, item = {}) {
      this.isDetailsActive = val;
      this.selectedTesimonial = item;
    },
    async mouseover() {
      // console.log("sumit", this.swiper);
      // this.swiper.autoplay.pause();
    },
    async mouseleave() {
      // console.log("sir ji");
      // this.swiper.autoplay.run();
    },
  },
};
</script>

<style lang="scss" scoped>
.example-3d {
  width: 100%;
}

.swiper {
  height: 100%;
  width: 100%;

  .swiper-slide {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 500px;
    height: 430px;
    text-align: center;
    font-weight: bold;
    font-size: 15px;
    background-position: center;
    background-size: cover;
    color: white;
    border: 10px solid #e9ddfa;
    border-radius: 25px;
    background-color: white !important;
  }

  .swiper-pagination {
    .swiper-pagination-bullet.swiper-pagination-bullet-active {
      background-color: white;
    }
  }
}
.border-user {
  border: 4px solid #0193a1;
  border-radius: 100%;
}
// .cust-bullet > .swiper-pagination-bullet {
// }
.cust-bullet > .swiper-pagination-bullet {
  width: 8px;
  height: 8px;
  display: inline-block;
  border-radius: 100%;
  background: #000;
  opacity: 0.2;
  margin-left: 3px !important;
  margin-right: 3px !important;
}
.cust-bg .swiper-container-3d .swiper-slide-shadow-right {
  background-image: -webkit-gradient(
    linear,
    left top,
    right top,
    from(rgba(146, 146, 146, 0.2)),
    to(rgba(0, 0, 0, 0))
  ) !important ;
  background-image: -webkit-linear-gradient(
    left,
    rgba(0, 0, 0, 0.5),
    rgba(0, 0, 0, 0)
  );
  background-image: -o-linear-gradient(
    left,
    rgba(0, 0, 0, 0.5),
    rgba(0, 0, 0, 0)
  );
  background-image: linear-gradient(
    to right,
    rgba(0, 0, 0, 0.5),
    rgba(0, 0, 0, 0)
  );
}
.cust-posi {
  position: initial !important;
  padding-top: 25px;
}
.testimonal-h650px {
  height: 650px;
}
@media (max-width: 640px) {
  .sm-h-675px {
    height: 675px !important;
  }
}
</style>
